import { render, staticRenderFns } from "./SMSCampaignGetStartedModal.vue?vue&type=template&id=5d900c7e&"
import script from "./SMSCampaignGetStartedModal.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignGetStartedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports